import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, ListChecks, Users, Settings } from 'lucide-react';
import { useT } from '@/lib/i18n';

const items = [
  { to: '/app', key: 'nav_home', icon: Home, testid: 'bottom-nav-home' },
  { to: '/app/rides', key: 'nav_rides', icon: ListChecks, testid: 'bottom-nav-rides' },
  { to: '/app/contacts', key: 'nav_contacts', icon: Users, testid: 'bottom-nav-contacts' },
  { to: '/app/account', key: 'nav_account', icon: Settings, testid: 'bottom-nav-account' },
];

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const t = useT();
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 mx-auto max-w-md px-3 pb-[max(env(safe-area-inset-bottom),10px)] pt-2"
      style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}
    >
      <div className="flex items-stretch justify-between">
        {items.map((it) => {
          const active = location.pathname === it.to;
          const Icon = it.icon;
          return (
            <button
              key={it.to}
              data-testid={it.testid}
              onClick={() => navigate(it.to)}
              className="flex-1 flex flex-col items-center justify-center gap-1 min-h-[52px] rounded-xl mx-0.5"
              style={{ color: active ? 'var(--primary)' : 'var(--text-muted)', background: active ? 'var(--surface-alt)' : 'transparent' }}
              aria-current={active ? 'page' : undefined}
            >
              <Icon size={22} strokeWidth={active ? 2.6 : 2} />
              <span className="text-[11px] font-medium">{t(it.key)}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
